var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "board",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M5,21H1c-0.6,0-1-0.4-1-0.9v-7.2C0,12.4,0.4,12,1,12h4c0.6,0,1,0.4,1,0.9v7.2C6,20.6,5.6,21,5,21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,9H1C0.4,9,0,8.6,0,8V4c0-0.5,0.4-1,1-1h4c0.6,0,1,0.5,1,1v4C6,8.6,5.6,9,5,9z M14,3h-4C9.4,3,9,3.5,9,4v12  c0,0.5,0.4,1,1,1h4c0.6,0,1-0.5,1-1V4C15,3.5,14.6,3,14,3z M23,3h-4c-0.5,0-1,0.5-1,1v4c0,0.6,0.5,1,1,1h4c0.5,0,1-0.4,1-1V4  C24,3.5,23.5,3,23,3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.64569de2.svg";
export { ForwardRef as ReactComponent };